// Budget

export const FETCHING_BUDGETS_DATES = '@@toyota/FETCHING_BUDGETS_DATES';
export const FETCHED_BUDGETS_DATES = '@@toyota/FETCHED_BUDGETS_DATES';
export const FETCHED_BUDGETS_DATES_FAILED = '@@toyota/FETCHED_BUDGETS_DATES_FAILED';

export const DELETING_BUDGET_DATE = '@@toyota/DELETING_BUDGET_DATE';
export const DELETED_BUDGET_DATE = '@@toyota/DELETED_BUDGET_DATE';
export const DELETE_BUDGET_DATE_FAILED = '@@toyota/DELETE_BUDGET_DATE_FAILED';

export const ADDING_BUDGET_DATE = '@@toyota/ADDING_BUDGET_DATE';
export const ADDED_BUDGET_DATE = '@@toyota/ADDED_BUDGET_DATE';
export const ADDING_BUDGET_DATE_FAILED = '@@toyota/ADDING_BUDGET_DATE_FAILED';

// VehiclesModel
export const FETCHING_VEHICLES_MODEL = '@@toyota/FETCHING_VEHICLES_MODEL';
export const FETCHED_VEHICLES_MODEL = '@@toyota/FETCHED_VEHICLES_MODEL';
export const FETCHED_VEHICLES_MODEL_FAILED = '@@toyota/FETCHED_VEHICLES_MODEL_FAILED';

export const DELETING_VEHICLES_MODEL = '@@toyota/DELETING_VEHICLES_MODEL';
export const DELETED_VEHICLES_MODEL = '@@toyota/DELETED_VEHICLES_MODEL';
export const DELETE_VEHICLES_MODEL_FAILED = '@@toyota/DELETE_VEHICLES_MODEL_FAILED';

export const ADDING_VEHICLES_MODEL = '@@toyota/ADDING_VEHICLES_MODEL';
export const ADDED_VEHICLES_MODEL = '@@toyota/ADDED_VEHICLES_MODEL';
export const ADDING_VEHICLES_MODEL_FAILED = '@@toyota/ADDING_VEHICLES_MODEL_FAILED';

export const UPDATING_VEHICLES_MODEL = '@@toyota/UPDATING_VEHICLES_MODEL';
export const UPDATED_VEHICLES_MODEL = '@@toyota/UPDATED_VEHICLES_MODEL';
export const UPDATED_VEHICLES_MODEL_FAILED = '@@toyota/UPDATED_VEHICLES_MODEL_FAILED';

// Vehicle Maintenance
export const FETCHING_VEHICLES_MAINTENANCE = '@@toyota/FETCHING_VEHICLES_MAINTENANCE';
export const FETCHED_VEHICLES_MAINTENANCE = '@@toyota/FETCHED_VEHICLES_MAINTENANCE';
export const FETCHED_VEHICLES_MAINTENANCE_FAILED = '@@toyota/FETCHED_VEHICLES_MAINTENANCE_FAILED';

export const UPDATING_VEHICLES_MAINTENANCE = '@@toyota/UPDATING_VEHICLES_MAINTENANCE';
export const UPDATED_VEHICLES_MAINTENANCE = '@@toyota/UPDATED_VEHICLES_MAINTENANCE';
export const UPDATED_VEHICLES_MAINTENANCE_FAILED = '@@toyota/UPDATED_VEHICLES_MAINTENANCE_FAILED';

// Manage Colors
export const FETCHING_MANAGE_COLORS = '@@toyota/FETCHING_MANAGE_COLORS';
export const FETCHED_MANAGE_COLORS = '@@toyota/FETCHED_MANAGE_COLORS';
export const FETCHED_MANAGE_COLORS_FAILED = '@@toyota/FETCHED_MANAGE_COLORS_FAILED';

export const UPDATING_MANAGE_COLORS = '@@toyota/UPDATING_MANAGE_COLORS';
export const UPDATED_MANAGE_COLORS = '@@toyota/UPDATED_MANAGE_COLORS';
export const UPDATED_MANAGE_COLORS_FAILED = '@@toyota/UPDATED_MANAGE_COLORS_FAILED';

export const CHANGE_VEHICLES_HISTORY_COLOR_STATE = '@@toyota/CHANGE_VEHICLES_HISTORY_COLOR_STATE';


// Manage Colors Add Form
export const CREATING_COLOR = '@@toyota/CREATING_COLOR';
export const CREATED_COLOR = '@@toyota/CREATED_COLOR';
export const CREATED_COLOR_FAILED = '@@toyota/CREATED_COLOR_FAILED';

// Vehicles History Colors
export const FETCHING_VEHICLES_HISTORY_COLORS = '@@toyota/FETCHING_VEHICLES_HISTORY_COLORS';
export const FETCHED_VEHICLES_HISTORY_COLORS = '@@toyota/FETCHED_VEHICLES_HISTORY_COLORS';
export const FETCHED_VEHICLES_HISTORY_COLORS_FAILED = '@@toyota/FETCHED_VEHICLES_HISTORY_COLORS_FAILED';

export const FETCHING_ACTIVE_COLORS = '@@toyota/FETCHING_ACTIVE_COLORS';
export const FETCHED_ACTIVE_COLORS = '@@toyota/FETCHED_ACTIVE_COLORS';
export const FETCHED_ACTIVE_COLORS_FAILED = '@@toyota/FETCHED_ACTIVE_COLORS_FAILED';

export const UPDATING_VEHICLES_HISTORY_COLORS = '@@toyota/UPDATING_VEHICLES_HISTORY_COLORS';
export const UPDATED_VEHICLES_HISTORY_COLORS = '@@toyota/UPDATED_VEHICLES_HISTORY_COLORS';
export const UPDATED_VEHICLES_HISTORY_COLORS_FAILED = '@@toyota/UPDATED_VEHICLES_HISTORY_COLORS_FAILED';

export const CREATING_VEHICLES_HISTORY_COLORS = '@@toyota/CREATING_VEHICLES_HISTORY_COLORS';
export const CREATED_VEHICLES_HISTORY_COLORS = '@@toyota/CREATED_VEHICLES_HISTORY_COLORS';
export const CREATED_VEHICLES_HISTORY_COLORS_FAILED = '@@toyota/CREATED_VEHICLES_HISTORY_COLORS_FAILED';

export const FETCHING_ACTIVE_PRICE_COLORS = '@@toyota/FETCHING_ACTIVE_PRICE_COLORS';
export const FETCHED_ACTIVE_PRICE_COLORS = '@@toyota/FETCHED_ACTIVE_PRICE_COLORS';
export const FETCHED_ACTIVE_PRICE_COLORS_FAILED = '@@toyota/FETCHED_ACTIVE_PRICE_COLORS_FAILED';

export const FETCHING_EMPTY_PRICE_COLORS = '@@toyota/FETCHING_EMPTY_PRICE_COLORS';
export const FETCHED_EMPTY_PRICE_COLORS = '@@toyota/FETCHED_EMPTY_PRICE_COLORS';
export const FETCHED_EMPTY_PRICE_COLORS_FAILED = '@@toyota/FETCHED_EMPTY_PRICE_COLORS_FAILED';

export const FETCHING_HISTORY_PRICE_COLORS = '@@toyota/FETCHING_HISTORY_PRICE_COLORS';
export const FETCHED_HISTORY_PRICE_COLORS = '@@toyota/FETCHED_HISTORY_PRICE_COLORS';
export const FETCHED_HISTORY_PRICE_COLORS_FAILED = '@@toyota/FETCHED_HISTORY_PRICE_COLORS_FAILED';

export const UPDATE_FIELD_PRICE_COLOR = '@@toyota/UPDATE_FIELD_PRICE_COLOR';
export const CLEAR_COLORS_HISTORY = '@@toyota/CLEAR_COLORS_HISTORY';

export const CREATING_ACTIVE_PRICE_COLORS = '@@toyota/CREATING_ACTIVE_PRICE_COLORS';
export const CREATED_ACTIVE_PRICE_COLORS = '@@toyota/CREATED_ACTIVE_PRICE_COLORS';
export const CREATED_ACTIVE_PRICE_COLORS_FAILED = '@@toyota/CREATED_ACTIVE_PRICE_COLORS_FAILED';

export const EDITING_ACTIVE_PRICE_COLORS = '@@toyota/EDITING_ACTIVE_PRICE_COLORS';
export const EDITED_ACTIVE_PRICE_COLORS = '@@toyota/EDITED_ACTIVE_PRICE_COLORS';
export const EDIT_ACTIVE_PRICE_COLORS_FAILED = '@@toyota/EDIT_ACTIVE_PRICE_COLORS_FAILED';

export const UPDATING_ACTIVE_PRICE_COLORS = '@@toyota/UPDATING_ACTIVE_PRICE_COLORS';
export const UPDATED_ACTIVE_PRICE_COLORS = '@@toyota/UPDATED_ACTIVE_PRICE_COLORS';
export const UPDATED_ACTIVE_PRICE_COLORS_FAILED = '@@toyota/UPDATED_ACTIVE_PRICE_COLORS_FAILED';

export const VALIDATING_PRICES_DATA = '@@toyota/VALIDATING_PRICES_DATA';
export const VALIDATED_PRICES_DATA = '@@toyota/VALIDATED_PRICES_DATA';
export const VALIDATE_PRICES_DATA_FAILED = '@@toyota/VALIDATE_PRICES_DATA_FAILED';

export const SAVING_MULTIPLE_COLOR_PRICES = '@@toyota/SAVING_MULTIPLE_COLOR_PRICES';
export const SAVED_MULTIPLE_COLOR_PRICES = '@@toyota/SAVED_MULTIPLE_COLOR_PRICES';
export const SAVE_MULTIPLE_COLOR_PRICES_FAILED = '@@toyota/SAVE_MULTIPLE_COLOR_PRICES_FAILED';

export const CLEAN_PRICES_DATA = '@@toyota/CLEAN_PRICES_DATA';
export const CLEAR_ACTIVE_PRICE_COLORS = '@@toyota/CLEAR_ACTIVE_PRICE_COLORS';

export const FETCHING_ACTIVE_PRODUCTIONS = '@@toyota/FETCHING_ACTIVE_PRODUCTIONS';
export const FETCHED_ACTIVE_PRODUCTIONS = '@@toyota/FETCHED_ACTIVE_PRODUCTIONS';
export const FETCHED_ACTIVE_PRODUCTIONS_FAILED = '@@toyota/FETCHED_ACTIVE_PRODUCTIONS_FAILED';

// Client Management
export const FETCHING_CLIENT_MANAGEMENT_LIST = '@@toyota/FETCHING_CLIENT_MANAGEMENT_LIST';
export const FETCHED_CLIENT_MANAGEMENT_LIST = '@@toyota/FETCHED_CLIENT_MANAGEMENT_LIST';
export const FETCHED_CLIENT_MANAGEMENT_LIST_FAILED =
  '@@toyota/FETCHED_CLIENT_MANAGEMENT_LIST_FAILED';
export const CLEAR_CLIENT_MANAGEMENT_LIST = '@@toyota/CLEAR_CLIENT_MANAGEMENT_LIST';
export const FETCHING_CLIENT_MANAGEMENT_INFO = '@@toyota/FETCHING_CLIENT_MANAGEMENT_INFO';
export const FETCHED_CLIENT_MANAGEMENT_INFO = '@@toyota/FETCHED_CLIENT_MANAGEMENT_INFO';
export const FETCHED_CLIENT_MANAGEMENT_INFO_FAILED = '@@toyota/FETCHED_CLIENT_MANAGEMENT_INFO_FAILED';
export const CLEAR_CLIENT_MANAGEMENT_INFO = '@@toyota/CLEAN_CLIENT_MANAGEMENT_INFO';
export const ADDING_CLIENT_MANAGEMENT_INFO = '@@toyota/ADDING_CLIENT_MANAGEMENT_INFO';
export const ADDED_CLIENT_MANAGEMENT_INFO = '@@toyota/ADDED_CLIENT_MANAGEMENT_INFO';
export const ADDED_CLIENT_MANAGEMENT_INFO_FAILED =
  '@@toyota/ADDED_CLIENT_MANAGEMENT_INFO_FAILED';
export const UPDATING_CLIENT_MANAGEMENT_INFO =
  '@@toyota/UPDATING_CLIENT_MANAGEMENT_INFO';
export const UPDATED_CLIENT_MANAGEMENT_INFO =
  '@@toyota/UPDATED_CLIENT_MANAGEMENT_INFO';
export const UPDATED_CLIENT_MANAGEMENT_INFO_FAILED =
  '@@toyota/UPDATED_CLIENT_MANAGEMENT_INFO_FAILED';
export const DELETING_CLIENT_MANAGEMENT_INFO = '@@toyota/DELETING_CLIENT_MANAGEMENT_INFO';
export const DELETED_CLIENT_MANAGEMENT_INFO = '@@toyota/DELETED_CLIENT_MANAGEMENT_INFO';
export const DELETED_CLIENT_MANAGEMENT_INFO_FAILED =
  '@@toyota/DELETED_CLIENT_MANAGEMENT_INFO_FAILED';
export const SET_CLIENT_INFO_FORM = '@@toyota/SET_CLIENT_INFO_FORM';

export const FETCHING_VERIFY_FLOAT_CLIENT = '@@toyota/FETCHING_VERIFY_FLOAT_CLIENT';
export const FETCHED_VERIFY_FLOAT_CLIENT = '@@toyota/FETCHED_VERIFY_FLOAT_CLIENT';
export const FETCHED_VERIFY_FLOAT_CLIENT_FAILED = '@@toyota/FETCHED_VERIFY_FLOAT_CLIENT_FAILED';

// Advisor Management
export const FETCHING_ADVISOR_MANAGEMENT_LIST = '@@toyota/FETCHING_ADVISOR_MANAGEMENT_LIST';
export const FETCHED_ADVISOR_MANAGEMENT_LIST = '@@toyota/FETCHED_ADVISOR_MANAGEMENT_LIST';
export const FETCHED_ADVISOR_MANAGEMENT_LIST_FAILED = '@@toyota/FETCHED_ADVISOR_MANAGEMENT_LIST_FAILED';
export const CLEAR_ADVISOR_MANAGEMENT_LIST = '@@toyota/CLEAR_ADVISOR_MANAGEMENT_LIST';
export const FETCHING_ADVISOR_MANAGEMENT_INFO = '@@toyota/FETCHING_ADVISOR_MANAGEMENT_INFO';
export const FETCHED_ADVISOR_MANAGEMENT_INFO = '@@toyota/FETCHED_ADVISOR_MANAGEMENT_INFO';
export const FETCHED_ADVISOR_MANAGEMENT_INFO_FAILED = '@@toyota/FETCHED_ADVISOR_MANAGEMENT_INFO_FAILED';
export const CLEAR_ADVISOR_MANAGEMENT_INFO = '@@toyota/CLEAR_ADVISOR_MANAGEMENT_INFO';
export const ADDING_ADVISOR_MANAGEMENT_INFO =
  '@@toyota/ADDING_ADVISOR_MANAGEMENT_INFO';
export const ADDED_ADVISOR_MANAGEMENT_INFO = '@@toyota/ADDED_ADVISOR_MANAGEMENT_INFO';
export const ADDED_ADVISOR_MANAGEMENT_INFO_FAILED =
  '@@toyota/ADDED_ADVISOR_MANAGEMENT_INFO_FAILED';
export const UPDATING_ADVISOR_MANAGEMENT_INFO = '@@toyota/UPDATING_ADVISOR_MANAGEMENT_INFO';
export const UPDATED_ADVISOR_MANAGEMENT_INFO =
  '@@toyota/UPDATED_ADVISOR_MANAGEMENT_INFO';
export const UPDATED_ADVISOR_MANAGEMENT_INFO_FAILED =
  '@@toyota/UPDATED_ADVISOR_MANAGEMENT_INFO_FAILED';
export const DELETING_ADVISOR_MANAGEMENT_INFO = '@@toyota/DELETING_ADVISOR_MANAGEMENT_INFO';
export const DELETED_ADVISOR_MANAGEMENT_INFO =
  '@@toyota/DELETED_ADVISOR_MANAGEMENT_INFO';
export const DELETED_ADVISOR_MANAGEMENT_INFO_FAILED = '@@toyota/DELETED_ADVISOR_MANAGEMENT_INFO_FAILED';

export const SET_ADVISOR_INFO_FORM = '@@toyota/SET_ADVISOR_INFO_FORM';


// Exemption Management
export const FETCHING_EXEMPTION_MANAGEMENT_LIST = '@@toyota/FETCHING_EXEMPTION_MANAGEMENT_LIST';
export const FETCHED_EXEMPTION_MANAGEMENT_LIST = '@@toyota/FETCHED_EXEMPTION_MANAGEMENT_LIST';
export const FETCHED_EXEMPTION_MANAGEMENT_LIST_FAILED = '@@toyota/FETCHED_EXEMPTION_MANAGEMENT_LIST_FAILED';
export const CLEAR_EXEMPTION_MANAGEMENT_LIST = '@@toyota/CLEAR_EXEMPTION_MANAGEMENT_LIST';
export const FETCHING_EXEMPTION_MANAGEMENT_INFO = '@@toyota/FETCHING_EXEMPTION_MANAGEMENT_INFO';
export const FETCHED_EXEMPTION_MANAGEMENT_INFO = '@@toyota/FETCHED_EXEMPTION_MANAGEMENT_INFO';
export const FETCHED_EXEMPTION_MANAGEMENT_INFO_FAILED = '@@toyota/FETCHED_EXEMPTION_MANAGEMENT_INFO_FAILED';
export const CLEAR_EXEMPTION_MANAGEMENT_INFO =
  '@@toyota/CLEAR_EXEMPTION_MANAGEMENT_INFO';
export const ADDING_EXEMPTION_MANAGEMENT_INFO = '@@toyota/ADDING_EXEMPTION_MANAGEMENT_INFO';
export const ADDED_EXEMPTION_MANAGEMENT_INFO = '@@toyota/ADDED_EXEMPTION_MANAGEMENT_INFO';
export const ADDED_EXEMPTION_MANAGEMENT_INFO_FAILED = '@@toyota/ADDED_EXEMPTION_MANAGEMENT_INFO_FAILED';
export const UPDATING_EXEMPTION_MANAGEMENT_INFO = '@@toyota/UPDATING_EXEMPTION_MANAGEMENT_INFO';
export const UPDATED_EXEMPTION_MANAGEMENT_INFO = '@@toyota/UPDATED_EXEMPTION_MANAGEMENT_INFO';
export const UPDATED_EXEMPTION_MANAGEMENT_INFO_FAILED = '@@toyota/UPDATED_EXEMPTION_MANAGEMENT_INFO_FAILED';
export const DELETING_EXEMPTION_MANAGEMENT_INFO = '@@toyota/DELETING_EXEMPTION_MANAGEMENT_INFO';
export const DELETED_EXEMPTION_MANAGEMENT_INFO = '@@toyota/DELETED_EXEMPTION_MANAGEMENT_INFO';
export const DELETED_EXEMPTION_MANAGEMENT_INFO_FAILED =
  '@@toyota/DELETED_EXEMPTION_MANAGEMENT_INFO_FAILED';
export const SET_DISABILITY_VALUE_FROM = '@@toyota/SET_DISABILITY_VALUE_FROM';


// Extra types
export const FETCHING_CONTRIBUTOR_TYPES = '@@toyota/FETCHING_CONTRIBUTOR_TYPES';
export const FETCHED_CONTRIBUTOR_TYPES = '@@toyota/FETCHED_CONTRIBUTOR_TYPES';
export const FETCHED_CONTRIBUTOR_TYPES_FAILED = '@@toyota/FETCHED_CONTRIBUTOR_TYPES_FAILED';

export const FETCHING_PROVINCES = '@@toyota/FETCHING_PROVINCES';
export const FETCHED_PROVINCES = '@@toyota/FETCHED_PROVINCES';
export const FETCHED_PROVINCES_FAILED = '@@toyota/FETCHED_PROVINCES_FAILED';

export const FETCHING_CLIENT_TYPES = '@@toyota/FETCHING_CLIENT_TYPES';
export const FETCHED_CLIENT_TYPES = '@@toyota/FETCHED_CLIENT_TYPES';
export const FETCHED_CLIENT_TYPES_FAILED = '@@toyota/FETCHED_CLIENT_TYPES_FAILED';

export const FETCHING_CITIES_CODES = '@@toyota/FETCHING_CITIES_CODES';
export const FETCHED_CITIES_CODES = '@@toyota/FETCHED_CITIES_CODES';
export const FETCHED_CITIES_CODES_FAILED = '@@toyota/FETCHED_CITIES_CODES_FAILED';

// Manage files

export const FETCHING_FLOATING_INVENTORY_ATTACHMENTS = '@@toyota/FETCHING_FLOATING_INVENTORY_ATTACHMENTS';
export const FETCHED_FLOATING_INVENTORY_ATTACHMENTS = '@@toyota/FETCHED_FLOATING_INVENTORY_ATTACHMENTS';
export const FETCHED_FLOATING_INVENTORY_ATTACHMENTS_FAILED = '@@toyota/FETCHED_FLOATING_INVENTORY_ATTACHMENTS_FAILED';

export const SAVING_FLOATING_INVENTORY_ATTACHMENTS = '@@toyota/SAVING_FLOATING_INVENTORY_ATTACHMENTS';
export const SAVED_FLOATING_INVENTORY_ATTACHMENTS = '@@toyota/SAVED_FLOATING_INVENTORY_ATTACHMENTS';
export const SAVED_FLOATING_INVENTORY_ATTACHMENTS_FAILED = '@@toyota/SAVED_FLOATING_INVENTORY_ATTACHMENTS_FAILED';

export const OPEN_MODAL_INV_FILES = '@@toyota/OPEN_MODAL_INV_FILES';

export const SET_CURRENT_CLIENT_FILES = '@@toyota/SET_CURRENT_CLIENT_FILES';
export const SET_CURRENT_INFO_CERT_FILES = '@@toyota/SET_CURRENT_INFO_CERT_FILES';
export const SET_CURRENT_OTHERS_FILES = '@@toyota/SET_CURRENT_OTHERS_FILES';

export const CLEAR_FL_INVENTORY_FILES = '@@toyota/CLEAR_FL_INVENTORY_FILES';
export const SET_DISABLE_INVENTORY_FILES = '@@toyota/SET_DISABLE_INVENTORY_FILES';

export const FETCHING_ALL_ACTIVE_PRICES = '@@toyota/FETCHING_ALL_ACTIVE_PRICES';
export const FETCHED_ALL_ACTIVE_PRICES = '@@toyota/FETCHED_ALL_ACTIVE_PRICES';
export const FETCHED_ALL_ACTIVE_PRICES_FAILED = '@@toyota/FETCHED_ALL_ACTIVE_PRICES_FAILED';
